/**
 * The colour the plugin was hardcoded to before branding existed. It is the
 * SCSS fallback, the column default, the migration back-fill for existing
 * tenants and the seed for a tenant whose token carries no platform theme, so
 * nothing about the plugin's appearance changes until an editor says so.
 */
export const DEFAULT_PRIMARY_COLOR = '#e20074';
